$(".top-bar-menu__item").on("mouseover", function () {
  const current = $(this);

  if (current.hasClass("is-open")) {
    return;
  }

  current.addClass("is-open");
});

$(".top-bar-menu__item").on("mouseout", function () {
  const current = $(this);
  current.removeClass("is-open");
});

$("#ContactForm").on("submit", function (e) {
  e.preventDefault();
  console.log("Form submitted");
});

$(document).on("click", "#terms-and-condition-link", function (e) {
  e.preventDefault();

  const termsAndConditionModal = $("#terms-and-condition-modal");
  const modalOverlay = $("#modal-overlay");
  modalOverlay.addClass("full");

  if (termsAndConditionModal) {
    termsAndConditionModal.removeClass("hidden");
  }

  if (modalOverlay) {
    modalOverlay.addClass("active");
  }
});

$(document).on("click", "#close-terms-and-condition-modal", function (e) {
  e.preventDefault();
  const termsAndConditionModal = $("#terms-and-condition-modal");
  const modalOverlay = $("#modal-overlay");
  termsAndConditionModal.addClass("hidden");
  modalOverlay.removeClass("active");
  modalOverlay.removeClass("full");
});

$(document).on("click", "#save-to-email", function (e) {
  const saveToCartModal = $("#save-to-cart-modal");
  const subjectInput = $("#subject-input");
  const messageInput = $("#message-input");
  const saveToEmailSubmitButton = $("#save-to-email-submit-button");
  const modalOverlay = $("#modal-overlay");
  const body = $("body");

  modalOverlay.addClass("full");

  if (saveToCartModal) {
    saveToCartModal.removeClass("hidden");
  }

  if (modalOverlay) {
    modalOverlay.addClass("active");
  }

  if (saveToEmailSubmitButton) {
    saveToEmailSubmitButton.prop("disabled", false);
    saveToEmailSubmitButton.text("Submit");
  }

  if (subjectInput) {
    subjectInput.val("");
  }

  if (messageInput) {
    messageInput.val("");
  }

  if (body) {
    body.addClass("overflow-hidden");
  }
});

$(document).on("click", ".make-an-enquiry", function (e) {
  e.preventDefault();
  const makeAnEnquiryModal = $("#make-an-enquiry-modal");
  const modalOverlay = $("#modal-overlay");
  const body = $("body");

  modalOverlay.addClass("full");

  if (makeAnEnquiryModal) {
    makeAnEnquiryModal.removeClass("hidden");
  }

  if (modalOverlay) {
    modalOverlay.addClass("active");
  }

  if (body) {
    body.addClass("overflow-hidden");
  }
});

$(document).on("click", ".card .make-an-enquiry", function (e) {
  e.preventDefault();

  const makeAnEnquiryModal = $("#make-an-enquiry-modal");
  const productTitleInput = makeAnEnquiryModal.find(
    "input[name='product-title']"
  );
  const skuInput = makeAnEnquiryModal.find("input[name='sku']");
  const modalTitle = makeAnEnquiryModal.find(".modal-title");

  const current = $(this);
  const productCardWrapper = current.closest(".product-card-wrapper");

  // Clear the form
  makeAnEnquiryModal.find("input[name='wall_width']").val("");
  makeAnEnquiryModal.find("input[name='wall_height']").val("");
  makeAnEnquiryModal.find("textarea").val("");
  makeAnEnquiryModal.find("button[type='submit']").text("Submit");
  makeAnEnquiryModal.find("button[type='submit']").prop("disabled", false);

  // Set the product title and sku
  if (productTitleInput) {
    productTitleInput.val(
      productCardWrapper.find(".card__heading").text().trim()
    );
  }

  if (skuInput) {
    skuInput.val(productCardWrapper.find(".product_sku").text().trim());
  }

  if (modalTitle) {
    modalTitle.text("Make an enquiry - " + productTitleInput.val());
  }
});

$(document).on("click", ".modal-close", function (e) {
  e.preventDefault();
  const modal = $(this).closest(".modal-overlay");
  const modalOverlay = $("#modal-overlay");
  const body = $("body");

  if (modal) {
    modal.addClass("hidden");
  }

  if (modalOverlay) {
    modalOverlay.removeClass("active");
    modalOverlay.removeClass("full");
  }

  if (body) {
    body.removeClass("overflow-hidden");
  }
});

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(context, args), delay);
  };
}

/**
 * Quantity Input
 *
 * Debounce function to prevent multiple calls to the same function for quantity input
 * @param {Function} fn - The function to debounce
 * @param {number} delay - The delay in milliseconds
 * @returns {Function} - The debounced function
 */
$(document).on(
  "keyup",
  ".qty-input",
  debounce(function (e) {
    e.preventDefault();

    const input = $(this);
    const step = parseInt(input.attr("step") || 1, 10);
    const current = parseInt(input.val() || 0, 10);

    if (current % step !== 0) {
      const updatedValue = Math.round(current / step) * step || step;
      input.val(updatedValue);
    }
  }, 300)
);

/**
 * Header Menu
 *
 * Handle click event for header menu links
 * @param {Event} e - The click event
 * @returns {void}
 */
$(document).on("click", "summary.header__menu-item", function (e) {
  e.preventDefault();
  const link = $(this);
  const url = link.data("menu-url");
  window.location.href = url;
});

/**
 * Sort Dropdown
 *
 * Handle click event for sort dropdown
 * @param {Event} e - The click event
 * @returns {void}
 */
$(document).on(
  "click",
  ".facet-sort-dropdown .custom-dropdown-button",
  function (e) {
    e.preventDefault();
    const dropdown = $(this).closest(".facet-sort-dropdown");
    const menu = dropdown.find(".custom-dropdown-menu");
    const label = dropdown.find(".facet-filters__label");

    if (!dropdown || !menu) return;

    dropdown.toggleClass("is-open", !dropdown.hasClass("is-open"));
    if (label) {
      label.toggleClass("dropdown-active", !dropdown.hasClass("is-open"));
      menu.css("display", dropdown.hasClass("is-open") ? "grid" : "none");
    }
  }
);

/**
 * Sort Dropdown Item
 *
 * Handle click event for sort dropdown item
 * @param {Event} e - The click event
 * @returns {void}
 */
$(document).on(
  "click",
  ".facet-sort-dropdown .custom-dropdown-menu li",
  function (e) {
    e.preventDefault();
    const item = $(this);
    const value = item.data("value");
    const dropdown = item.closest(".facet-sort-dropdown");
    const label = dropdown.find(".facet-filters__label");
    const select = dropdown.closest("#SortBy");
    const ul = item.closest("ul");
    const selectedText = item
      .closest(".facet-sort-dropdown")
      .find(".custom-selected-text");

    if (selectedText) {
      selectedText.text(item.text());
    }

    if (dropdown) {
      dropdown.removeClass("is-open");
    }

    if (label) {
      label.removeClass("dropdown-active");
    }

    if (select.length > 0 && select.val() !== value) {
      select.val(value).change();
    } else {
      if (ul.length > 0 && ul.find("li.selected").data("value") !== value) {
        window.location.href = updateUrlParameter(
          window.location.href,
          "sort_by",
          value
        );
      }
    }
  }
);

/*
 * Ready to Ship Filter
 *
 * Handle change event for ready to ship filter
 * @param {Event} e - The change event
 * @returns {void}
 */
ready("#ReadyToShipFilter", (el) => {
  const params = new URLSearchParams(window.location.search);
  const filterDiscontinued = params.get("filter.p.m.custom.ready_to_ship");

  if (filterDiscontinued) {
    if (filterDiscontinued === "1") {
      $("#ReadyToShipFilter").prop("checked", true);
    }
  }
});

$(document).on("change", "#ReadyToShipFilter", function () {
  const showReady = $(this).is(":checked");
  const productGrid = $("#product-grid");

  if (productGrid.length > 0) {
    if (showReady) {
      window.location.href = updateUrlParameter(
        window.location.href,
        "filter.p.m.custom.ready_to_ship",
        1
      );
    } else {
      window.location.href = removeUrlParameter(
        window.location.href,
        "filter.p.m.custom.ready_to_ship"
      );
    }
  }
});

const updateUrlParameter = (uri, key, value) => {
  const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  const separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
};

const removeUrlParameter = (uri, key) => {
  const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  return uri.replace(re, "$1");
};

/**
 * Wait for an element to appear in the DOM and run a callback
 * @param {string} selector - CSS selector for the target element
 * @param {function} callback - Function to execute when element is found
 */
function ready(selector, callback) {
  const element = document.querySelector(selector);
  if (element) {
    callback(element);
    return; // element already exists, no need to observe
  }

  const observer = new MutationObserver((mutations, obs) => {
    const el = document.querySelector(selector);
    if (el) {
      callback(el); // run your custom logic
      obs.disconnect(); // stop observing
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
